import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import { I18n, Translate } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';

import EmptyClassroomStudentPlaceholder from './EmptyClassroomStudentPlaceholder';
import EmptyClassroomTeacherPlaceholder from './EmptyClassroomTeacherPlaceholder';
import DragAndDropContainer from '../../../common/DragAndDropContainer';

import ClassroomCardPlaceholder from '../../../../components/classroom/ClassroomCardPlaceholder';

import * as bookActions from '../../../../actions/bookActions';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import { ROLE, ROUTES } from '../../../../const';
import { ClassroomActiveCard } from './ClassroomActive.card';
import NewContentCard from '../../../book/NewContentCard';
import { Link } from 'react-router';

class ClassroomActiveContainer extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.openAddModal = this.openAddModal.bind(this);
    this.openEnrollModal = this.openEnrollModal.bind(this);
    this.appWidth = 0;
  }

  static propTypes = {
    classroomActions: PropTypes.any,
    role: PropTypes.string,
    isAppOnline: PropTypes.any,
    activeClassrooms: PropTypes.any,
    user: PropTypes.object,
    fetchingClassrooms: PropTypes.bool,
    enableCreateClass: PropTypes.bool,
    enableEnrollment: PropTypes.bool,
    archiveEnabled: PropTypes.bool
  };

  componentDidMount() {
    this.appWidth = $(window).width();
  }

  isTeacher() {
    const { role } = this.props;
    return role === ROLE.INSTRUCTOR;
  }

  isDraggable() {
    const { isAppOnline } = this.props;
    return isAppOnline;
  }

  renderStaticCard() {
    let customMessage = this.isTeacher() ? I18n.t('home.newClassroom') : I18n.t('home.joinClassroom');

    return (
      <NewContentCard
        customMessage={customMessage}
        customCss="book-card-new-large"
        onClick={this.isTeacher() ? this.openAddModal : this.openEnrollModal}
      />
    );
  }

  openAddModal() {
    const { isAppOnline } = this.props;
    if (isAppOnline) {
      let { classroomActions } = this.props;
      classroomActions.setAddModalState(true);
    }
  }

  openEnrollModal() {
    let { classroomActions } = this.props;
    classroomActions.setEnrollModalState(true);
  }

  renderCard(card) {
    let { key, item, isDragging } = card;

    return (
      <ClassroomActiveCard
        key={key}
        id={item.id}
        classCode={item.classCode}
        name={item.name}
        studentsCount={item.studentsCount || 0}
        picture={item.picture}
        asset={item.asset}
        isDragging={isDragging}
        role={item.role}
      />
    );
  }

  handlerAfterMoveCard(newClassroomOrder) {
    const { classroomActions } = this.props;
    classroomActions.changePositionClassroom(newClassroomOrder);
  }

  renderContent() {
    let content;
    const { activeClassrooms, fetchingClassrooms, enableCreateClass, enableEnrollment } = this.props;
    if (fetchingClassrooms) {
      content = <ClassroomCardPlaceholder key="CardsPlaceholder" id="CardsPlaceholder" />;
    } else if (activeClassrooms && activeClassrooms.length) {
      content = (
        <DragAndDropContainer
          cardId="id"
          cards={activeClassrooms}
          rotation={5}
          containerClassName="classroom-active-container no-user-selection"
          renderCard={this.renderCard.bind(this)}
          handlerAfterMoveCard={this.handlerAfterMoveCard.bind(this)}
          dragActivated={this.isDraggable()}
          renderStaticCard={
            enableCreateClass && this.isTeacher()
              ? this.renderStaticCard.bind(this)
              : enableEnrollment && !this.isTeacher()
              ? this.renderStaticCard.bind(this)
              : undefined
          }
          id="classroomActiveContainer"
        />
      );
    } else if (activeClassrooms && !activeClassrooms.length) {
      if (this.isTeacher()) {
        content = <EmptyClassroomTeacherPlaceholder />;
      } else {
        content = <EmptyClassroomStudentPlaceholder />;
      }
    }
    return content;
  }

  render() {
    const { user, archiveEnabled } = this.props;

    return (
      <div className="classrooms-container">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 25 }}>
          <span data-cy="welcomeMessage" className={'classroom-container-title'}>{`${I18n.t('home.welcome')}, ${
            user ? user.name : ''
          }!`}</span>
          {this.isTeacher() && archiveEnabled && (
            <Link to={ROUTES.ARCHIVE} onlyActiveOnIndex={false}>
              <span style={{ marginRight: '30px', color: '#3083a0', cursor: 'pointer' }}>
                <Translate value="leftMenu.archive" />
              </span>
            </Link>
          )}
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeClassrooms: state.classrooms.activeClassrooms.sort((a, b) => a.position - b.position),
    fetchingClassrooms: state.classrooms.fetching,
    archiveModalIsOpen: state.classrooms.archiveModalIsOpen,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    role: state.account.user.role,
    enableCreateClass: state.account.configuration.enableCreateClass,
    enableEnrollment: state.account.configuration.enableEnrollment,
    archiveEnabled: state.account.configuration.archiveEnabled,
    user: state.account.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomActiveContainer);
